
import { Component, Mixins } from "vue-property-decorator";
import { IRangeOfMotionGroupKeyPropertyEditable, instanceOfIRangeOfMotionGroupKeyPropertyEditable } from "../../../../../domain/editableFormat/properties";

@Component
export default class RangeOfMotionGroupKeyPropertyEditableMixin extends Mixins() {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: IRangeOfMotionGroupKeyPropertyEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IRangeOfMotionGroupKeyPropertyEditable) => T, defaultValue: T) => T;

  // ドメイン層のエンティティは全てinterfaceにしてるが、
  // 本体のコンポーネントは従来のクラスエンティティで実装されてるのでそっちに合わせないと既存部品を再利用できない。
  // Vueの世界の話なのでコンポーネント側の実装で吸収する。

  get isRangeOfMotionGroupKeyEditable(): boolean {
    return this.readPropertyOrDefault(s => instanceOfIRangeOfMotionGroupKeyPropertyEditable(s) && s.rangeOfMotionGroupKey().isEditable(), false);
  }

  get rangeOfMotionGroupKey(): string {
    return this.readPropertyOrDefault(s => s.rangeOfMotionGroupKey().getValue(), "");
  }

  set rangeOfMotionGroupKey(value: string) {
    this.writePropertyWhenValid(s => s.rangeOfMotionGroupKey().setValue(value));
  }
}
